import React from 'react'
import { FormattedMessage } from 'react-intl'
import AgreementCheckbox from '../../components/common/AgreementCheckbox'
import { getCookie } from '../../components/common/cookie'

const mappingLang = {
  sc: 'SC',
  tc: 'TC',
  en: 'EN',
}

const Agreement = ({ checkedChange, checkedTimes, checkedAgreement }) => {
  const lang = getCookie('language')
  const onCheckedChange = (type, checked) => {
    checkedChange({ [type]: checked })
  }
  return (
    <>
      <AgreementCheckbox checked={checkedTimes} setChecked={(checked) => onCheckedChange('checkedTimes', checked)}>
        <FormattedMessage id="dm-form-agreement-60-dives" />
      </AgreementCheckbox>
      <AgreementCheckbox
        checked={checkedAgreement}
        setChecked={(checked) => onCheckedChange('checkedAgreement', checked)}
      >
        <FormattedMessage
          id="dm-form-agreement-text"
          values={{
            link: (
              <a
                href={`https://assets.padi.com.cn/agreements/10125${mappingLang[lang]}.pdf`}
                rel="noreferrer noopener"
                target="_blank"
              >
                <FormattedMessage id="dm-form-agreement-link" />
              </a>
            ),
          }}
        />
      </AgreementCheckbox>
    </>
  )
}

export default Agreement
